import React, { useState } from 'react';
import { useZitoneoHotelPresentation } from '../../../contexts/ZitoneoContentContext';
import LoadingPlaceholder from '../../../../../muiComponents/LoadingPlaceholder';
import useTranslate from '../../../../../customHooks/useTranslate';
import ServiceScraperPanel from './ServiceScraperPanel';
import { ProviderServiceScraperPanel } from '../../../contexts/ServiceScraperPanelContext';
import { Tab, Tabs } from '@mui/material';
import ServiceScrapingNew from './ServiceScrapingNew';
import ServiceScrapingHistory from './ServiceScrapingHistory';
import LoadingServiceScrapingSectionContent from './LoadingServiceScrapingSectionContent';

const ServiceScrapingSectionContent = () => {
    const { isLoading } = useZitoneoHotelPresentation();
    const translate = useTranslate();
    const [selectedTab, setSelectedTab] = useState<'new' | 'history'>('new');

    return (
        <>
            <section
                className='hotel-presentation__section'
                id='service-scraper'
            >
                {isLoading ? (
                    <LoadingPlaceholder
                        variant='text'
                        width={150}
                        height={24}
                        aria-hidden='true'
                    />
                ) : (
                    <h2 className='hotel-presentation__section-title'>
                        {translate('autoimport_with_ai')}
                    </h2>
                )}
                <div
                    className='hotel-presentation__section-content padding-top-5'
                    aria-busy={isLoading}
                >
                    {isLoading ? (
                        <LoadingServiceScrapingSectionContent />
                    ) : (
                        <>
                            <Tabs
                                value={selectedTab}
                                onChange={(
                                    _: React.SyntheticEvent,
                                    value: 'new' | 'history'
                                ) => setSelectedTab(value)}
                                className='border-color-bottom'
                            >
                                <Tab
                                    id='service-scraping-new-tab'
                                    aria-controls='service-scraping-new-panel'
                                    value='new'
                                    label={translate('new_analysis')}
                                />
                                <Tab
                                    id='service-scraping-history-tab'
                                    aria-controls='service-scraping-history-panel'
                                    value='history'
                                    label={translate('history')}
                                />
                            </Tabs>
                            {selectedTab === 'new' ? (
                                <ServiceScrapingNew />
                            ) : (
                                <ServiceScrapingHistory />
                            )}
                        </>
                    )}
                </div>
            </section>
            <ServiceScraperPanel />
        </>
    );
};

const ServiceScrapingSection = () => (
    <ProviderServiceScraperPanel>
        <ServiceScrapingSectionContent />
    </ProviderServiceScraperPanel>
);

export default ServiceScrapingSection;
